import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { setUserId, trackPageView } from './analytics'
import { useAuth0 } from '@auth0/auth0-react'
// import { getMyIPAddress } from './utils/ip_address'

export default function RouteChangeTracker() {
  const location = useLocation()
  const { user } = useAuth0()

  useEffect(() => {
    let cancelled = false;

    const trackPage = async () => {
      // const ip = await getMyIPAddress()
      if (cancelled) return
      if (user?.sub) setUserId(user.sub);
      trackPageView(location.pathname + location.search);
    }

    trackPage();

    return () => { cancelled = true }
  }, [location.pathname, location.search, user])

  return null
}
